import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar.js';
import { Topbar } from './Topbar.js';

export function Layout() {
  return (
    <>
      <Sidebar />
      <main>
        <Topbar />
        <div className="content">
          <div className="content-inner">
            <Outlet />
          </div>
        </div>
      </main>
    </>
  );
}
